import { Users } from "lucide-react";
import { StakeholdersBlock } from "@/canvas/components/blocks/StakeholdersBlock";
import type { BlockConfig } from "../types";

export const stakeholdersBlockConfig: BlockConfig<"stakeholders"> = {
  type: "stakeholders",
  component: StakeholdersBlock,
  icon: Users,
  iconClassName: "text-rose-500",
  label: "canvas.blockTypes.stakeholders",
  defaultContent: () => ({
    stakeholders: [],
  }),
};
